export const AppThemeMode = {
  AUTO: 'auto',
  LIGHT: 'light',
  DARK: 'dark'
} as const;

export type AppThemeMode = (typeof AppThemeMode)[keyof typeof AppThemeMode];
